/**
 * Pixel-art pizza ingredients — the food of the snake game. All but the
 * pineapple come round regularly; the pineapple is the rare easter egg, and
 * the chili makes the snake hot (rules in round.js).
 *
 * 10×10 pixels each, '.' is transparent, every other character is a key of
 * the sprite's palette. Drawn over 2×2 grid cells by the renderer.
 */
export const INGREDIENTS = {
  tomato: {
    palette: { g: '#3f9b35', G: '#6cc04a', r: '#e3342c', h: '#ff8f7e', d: '#a31d19' },
    rows: [
      '....gG....',
      '..gGGGgg..',
      '.rrrgGrrr.',
      'rrhhrrrrrr',
      'rhhrrrrrrr',
      'rrhrrrrrrd',
      'rrrrrrrrrd',
      '.rrrrrrrd.',
      '..rrrrdd..',
      '....dd....',
    ],
  },
  mushroom: {
    palette: { c: '#9c6b3f', C: '#c99665', H: '#e2bb8d', s: '#f3e7d3', S: '#d6c5a8' },
    rows: [
      '...cccc...',
      '.cCCHHCCc.',
      'cCCHHCCCCc',
      'cCCCCCCCCc',
      'cccccccccc',
      '..sssssS..',
      '...sssS...',
      '...sssS...',
      '..sssssS..',
      '...SSSS...',
    ],
  },
  fish: {
    palette: { b: '#7fa9c9', B: '#b9d6ea', d: '#4f7a9c', k: '#15202b', t: '#5d8db3' },
    rows: [
      '..........',
      '...dddd...',
      '.dbbbbbd.t',
      'dbBkbbbbdt',
      'dBBBBbbbtt',
      'dbbbbbbbtt',
      '.dbbbbbd.t',
      '...dddd...',
      '..........',
      '..........',
    ],
  },
  ham: {
    palette: { p: '#c24d63', P: '#ec8798', w: '#fbe3e6' },
    rows: [
      '...wwww...',
      '.wwPPPPw..',
      'wPPPPPPPw.',
      'wPpPPPPPPw',
      '.wPPPpPPPw',
      '..wPPPPpPw',
      '..wPpPPPPw',
      '...wPPPPw.',
      '....wwww..',
      '..........',
    ],
  },
  mozzarella: {
    palette: { w: '#ffffff', s: '#dfe4ea', S: '#b9c2cc', h: '#ffffff' },
    rows: [
      '...ssss...',
      '.sswwwwss.',
      'swwwwwwwws',
      'swwhhwwwws',
      'swwhwwwwws',
      'swwwwwwwss',
      'swwwwwwsss',
      '.sswwsssS.',
      '..SSSSSS..',
      '..........',
    ],
  },
  spinach: {
    palette: { g: '#1f6b2c', G: '#2f8f3c', v: '#7cc36a', s: '#4e9a3b' },
    rows: [
      '......gg..',
      '....gGGGg.',
      '...gGGvGGg',
      '..gGGvGGGg',
      '.gGGvGGGg.',
      '.gGvGGGg..',
      'gGvGGGg...',
      'gvGGgg....',
      'sgg.......',
      's.........',
    ],
  },
  pineapple: {
    palette: { g: '#3d8f3a', G: '#63b84e', y: '#f2c233', Y: '#ffe07a', o: '#c98a1c' },
    rows: [
      '...g.Gg...',
      '....GgG...',
      '...GgGg...',
      '..oyyyyo..',
      '.oyYyoyYo.',
      '.yoyYyoyy.',
      '.yYoyyYoy.',
      '.oyyoYyyo.',
      '..oyyyyo..',
      '...oooo...',
    ],
  },
  cow: {
    palette: { w: '#ffffff', k: '#1d1d1b', p: '#f2a7b5', P: '#d97a8d', h: '#d9d2c5', e: '#1d1d1b' },
    rows: [
      'h........h',
      'hkwwwwwwkh',
      '.kkwwwwkw.',
      '.wewwwwew.',
      '.wwkwwwww.',
      '.wwwwwkkw.',
      '..pppppp..',
      '..pPppPp..',
      '..pppppp..',
      '..........',
    ],
  },
  pig: {
    palette: { p: '#f7b3c2', P: '#e58aa0', n: '#d86a85', e: '#1d1d1b' },
    rows: [
      '.PP....PP.',
      '.PpP..PpP.',
      '.pppppppp.',
      'pppppppppp',
      'ppeppppepp',
      'pppnnnnppp',
      'pppnPPnppp',
      'pppnnnnppp',
      '.pppppppp.',
      '..pppppp..',
    ],
  },
  basil: {
    palette: { g: '#2e8b36', G: '#57b845', v: '#9bdc7f', s: '#2e6b2a' },
    rows: [
      '..........',
      '...gg.....',
      '..gGGg.gg.',
      '.gGvGggGGg',
      '.gGGvgGvGg',
      '..gGGsGGg.',
      '...gsgg...',
      '....s.....',
      '....s.....',
      '..........',
    ],
  },
  olive: {
    palette: { k: '#2b2626', K: '#4a4242', h: '#8a7f7f' },
    rows: [
      '..........',
      '..kkkkkk..',
      '.kKKKKKKk.',
      'kKhKkkKKKk',
      'kKKk..kKKk',
      'kKKk..kKKk',
      'kKKKkkKKKk',
      '.kKKKKKKk.',
      '..kkkkkk..',
      '..........',
    ],
  },
  chili: {
    palette: { g: '#3f9b35', r: '#d9241c', R: '#ff5a45', d: '#9e1812' },
    rows: [
      '........g.',
      '.......gg.',
      '......ggr.',
      '.....rRrr.',
      '....rRrrd.',
      '...rRrrd..',
      '..rRrrd...',
      '.rRrrd....',
      'rrrdd.....',
      'rd........',
    ],
  },
  salami: {
    palette: { r: '#a3222f', R: '#c8394a', w: '#f6d7dc', d: '#7a1823' },
    rows: [
      '...dddd...',
      '.ddRRRRdd.',
      '.dRwRRRRd.',
      'dRRRRRwRRd',
      'dRRwRRRRRd',
      'dRRRRRRwRd',
      'dRwRRRRRRd',
      '.dRRRwRRd.',
      '.ddRRRRdd.',
      '...dddd...',
    ],
  },
  onion: {
    palette: { p: '#8e3a7a', P: '#b95d9f', w: '#f1d7ea' },
    rows: [
      '..........',
      '..pppppp..',
      '.pPwwwwPp.',
      'pPwpppPwPp',
      'pwpw..wpwp',
      'pwpw..wpwp',
      'pPwpppPwPp',
      '.pPwwwwPp.',
      '..pppppp..',
      '..........',
    ],
  },
  egg: {
    palette: { w: '#ffffff', s: '#e6e2da', y: '#ffb321', Y: '#ffd66b', o: '#e08a0b' },
    rows: [
      '..wwww....',
      '.wwwwwww..',
      'wwwwwwwwws',
      'wwwyyyywws',
      'wwyYYyyyws',
      'wwyYyyyows',
      'wwwyyoowws',
      '.wwwwwwws.',
      '..swwwwss.',
      '....sss...',
    ],
  },
  garlic: {
    palette: { w: '#f7f2e8', s: '#d9cfbd', l: '#b9a98e', g: '#8fae5a' },
    rows: [
      '....g.....',
      '....ll....',
      '...wwws...',
      '..wwwwss..',
      '.wwswwwss.',
      'wwwswwwwss',
      'wwwswwwsws',
      'wwwswwwsws',
      '.wwswwsss.',
      '..llllll..',
    ],
  },
}

export const INGREDIENT_NAMES = Object.keys(INGREDIENTS)
